import { ApplyQuestion } from '../lib/ApplyQuestion';
import { SelectDocument } from '../lib/SelectDocument';
import { ProfileAvatar } from '../lib/ProfileAvatar';

$('.form-group-checkboxes').each((groupKey, group) => {
    $('input:checked', $(group)).each((checkboxKey, checkbox) => {
        $(checkbox).closest('label').addClass('is-checked');
    });
});

new ApplyQuestion($('.form-group-apply-question'));
new SelectDocument($('.form-group-apply-document'), 'input[name="cv"]');
new ProfileAvatar($('.avatar-image-container'));

// Education & Skills
if (jQuery().select2) {
    $('#mainSubject, #placeOfStudy, #jointSubject').select2({
        allowClear: true,
    });
    $('#languages, #editSkillsForm\\.languages').select2({
        maximumSelectionSize: 8,
    });

    // Interests
    $('.select2-locations, .select2-institutions').each(
        function createSelect2() {
            let tnrs = '';
            if ($(this).hasClass('select2-locations'))
                tnrs = 'UK_TOWN_CITY,COUNTRY,REGION';
            if ($(this).hasClass('select2-institutions')) tnrs = 'HEI_PG';

            $(this)
                .select2({
                    placeholder: 'All locations',
                    multiple: true,
                    minimumInputLength: 2,
                    allowClear: true,
                    ajax: {
                        url: `/api/taxonomy/grouped_categories_by_keyword?subject_categories=${tnrs}`,
                        dataType: 'json',
                        data(term) {
                            return { keyword: term };
                        },
                        results(data) {
                            return { results: data.results };
                        },
                    },
                    initSelection(element, callback) {
                        const selectedItems = element.data('selected-items')
                            ? element.data('selected-items').join(',')
                            : null;
                        const data = [];
                        if (selectedItems) {
                            $.ajax({
                                url: `/api/taxonomy/category_names_for_tnrs?tnrs=${selectedItems}`,
                            })
                                .then((res) => {
                                    $(res).each(function populateOptions() {
                                        data.push({
                                            id: this.tnr,
                                            text: this.text,
                                        });
                                    });
                                })
                                .always(() => {
                                    callback(data);
                                });
                        } else {
                            callback(data);
                        }
                    },
                })
                .select2('val', {});
        }
    );

    $('select.select2-simple').each(function () {
        $(this).select2({
            allowClear: $(this).data('clear'),
        });
    });
}

// Well summary/details

$('.well-body-summary[aria-controls]').each(function createPair() {
    const $summary = $(`#${$(this).attr('aria-controls')}`);
    const $checkboxes = $(this).find('input[type="checkbox"]');

    function populated() {
        return $checkboxes.is(':checked');
    }

    if (!populated()) {
        $summary.addClass('hidden');
    }

    $checkboxes.on('change', () => {
        if (populated()) {
            $summary.removeClass('hidden');
        } else {
            $summary.addClass('hidden');
        }
    });
});

//Email already existing validation
if (
    window.location.pathname === '/fair-register' ||
    window.location.pathname === '/register'
) {
    $('#email').blur(function () {
        const emailValue = $(this).val();
        const emailStatus = $('#emailStatus');
        if (emailValue !== null && emailValue !== '') {
            $(this).siblings('.error-block').remove();
            $.ajax({
                url: '/api/isEmailTaken',
                type: 'POST',
                data: { email: emailValue },
            })
                .then(function (data) {
                    if (data) {
                        if (window.location.pathname === '/fair-register') {
                            $('#email').attr(
                                'aria-labelledby',
                                'email-label emailStatus'
                            );
                            emailStatus.css('display', 'block');
                            emailStatus.html(
                                `The email address '${emailValue}' is already taken.`
                            );
                            emailStatus.addClass('has-error');
                        } else {
                            $('#email').attr(
                                'aria-labelledby',
                                'email-label emailStatus'
                            );
                            emailStatus.css('display', 'block');
                            emailStatus.html(
                                `The email address '${emailValue}' is already taken.<span class='links-no-wrapping'><a href='/login' class='no-wrap'>Log in</a> <a href='/reset-password' class='no-wrap'>Forgotten password</a></span>`
                            );
                            emailStatus.addClass('has-error');
                        }
                    } else {
                        $('#email').attr('aria-labelledby', 'email-label');
                        emailStatus.css('display', 'none');
                        emailStatus.html('');
                        emailStatus.removeClass('has-error');
                    }
                })
                .fail(function () {
                    emailStatus.css('display', 'block');
                    emailStatus.html(
                        'Sorry, we are unable to register you at the moment, please try again in a few minutes.'
                    );
                });
        }
    });
}

$(document).ready(() => {
    // In case of errors during the submit
    if (
        $('#genderIdentity option:selected').filter(":contains('Not listed')")
            .length === 1 ||
        $('#customGenderIdentity').val() !== ''
    ) {
        $('.registration-gender').addClass('is-open');
        $('.registration-custom-gender').css('display', 'block');
        $('.registration-custom-gender').css('opacity', '1');
    }
    if (
        $('#ethnicIdentity option:selected').filter(":contains('Not listed')")
            .length === 1 ||
        $('#customEthnicIdentity').val() !== ''
    ) {
        $('.registration-ethnic').addClass('is-open');
        $('.registration-custom-ethnic').css('display', 'block');
        $('.registration-custom-ethnic').css('opacity', '1');
    }
});

$('#genderIdentity').on('change', () => {
    if (
        $('#genderIdentity option:selected').filter(":contains('Not listed')")
            .length === 1
    ) {
        $('.registration-gender').addClass('is-open');
        $('.registration-custom-gender').css('display', 'block');
        setTimeout(() => {
            $('.registration-custom-gender').css('opacity', '1');
        }, 400);
    } else {
        $('#customGenderIdentity').val('');
    }
});
$('#ethnicIdentity').on('change', () => {
    if (
        $('#ethnicIdentity option:selected').filter(":contains('Not listed')")
            .length === 1
    ) {
        $('.registration-ethnic').addClass('is-open');
        $('.registration-custom-ethnic').css('display', 'block');
        setTimeout(() => {
            $('.registration-custom-ethnic').css('opacity', '1');
        }, 400);
    } else {
        $('#customEthnicIdentity').val('');
    }
});

$('body').on('click', '.js-error-summary a', function (e) {
    e.preventDefault();
    const id = this.hash.split('#').pop();
    const shouldTargetLegend =
        id === 'expectedMonthOfGraduation' ||
        id === 'expectedYearOfGraduation' ||
        id === 'monthGraduated' ||
        id === 'yearGraduated' ||
        id === 'monthCourseStarted' ||
        id === 'yearCourseStarted';
    let $target = $(`[for=${id}]`);
    $target = shouldTargetLegend
        ? $target.closest('fieldset').find('legend')
        : $target.length
        ? $target
        : $(`#${id}`);

    $('html, body').animate(
        {
            scrollTop: $target.offset().top,
        },
        500
    );
    $(this.hash).focus();
});
